// Main
import { useEffect, useState, useRef, useMemo } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Form,
    ProTableOt,
    Card,
    jsonToQueryString,
    Tabs,
    Typography,
    Divider,
    Switch
} from "../ot";
import { useCRUDController } from "./CRUDController";
import ClassifyStructureModal from "./ClassifyStructureModal";
import ClassifyStructureForm from "./ClassifyStructureForm"
import throttle from 'lodash/throttle';
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import ClassifyStructureDepthForm from './classify_structure_depth_form'
import { ColumnExtendButton, PropertyJson } from "./depth_data_management";
// import Tree from 'react-d3-tree';
import Tree from 'react-d3-tree';
import { toPng } from 'html-to-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faArrowDown, faArrowUp, faArrowLeft, faArrowRight, faFileImport, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const Main = ({
    selectRef,
    forceReload = 0,
    propsForm = null,
    prefixTitle = "",
    classify_structure_id = 0,
    classify_structure_type_id = 0,
    classify_structure_id_arr = '[0]',
    multipleClassifyStructure = false,
    initialValues = {},
    apiRoute = "/utility/classify_structure_type",
    apiRouteDepth = apiRoute + '_depth',
    extraParams,
    customColumns = [],
    customColumnsSuffix = [],
    customFormItems = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    defaultValue = {},
    propsLoading,
    custom_multiple_input = false, //後端預設新增是多筆或是單筆
    // onChange = () => { },
    propsOnValueChange = () => { }, //注意 propsOnValueChange 命名不同 propsOnValuesChange
    // onSubmit = () => { },
    // onSortable = () => { },
    // deleteNode = () => { },
    // onSelect = () => { },
    onSelectChange = () => { },
    reorganizeFormData = (value, type) => {
        return { ...value };
    },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    rowSelectionMode = "checkbox",
    // propsPatchOnBefore = () => { },
    // propsPatchonFinish = () => { },
    // PropsPatchForm = () => <></>,
    // propsUseData = () => { },
    propsPatch = true,
    // propsPatchProcess = () => { },
    // modalOpen = false,
    // setModalOpen = () => { },
    propsDelete = true,
    // propsDeleteOnBefore = () => { },
    // propsDeleteonFinish = () => { },
    propsPost = true,
    propsPostChildren = true,
    propsPostChildrenKey = [],//post children可以先拿到key
    propsWidth = 1000,
    showMode = "page",
    cardRender = () => { },
    cardModeSetting = {
        columnsCount: 5,
        singleRowHeight: 60,
    },
    propsDeleteModal = false,
    propsChildrenText,
    propsSort = true,
    propsDepth = false,
    propsExtend = false,
    propsName = false,
    propsRenderChildrenDataOuter = false,
    renderChildrenData: renderChildrenData_ = () => { },
    readonly = false,
    propsFirstDepth = '系統角色',
    formMode = false,//觸發必填的form
    propsShowKeys = [ //是否顯示名稱
        { key: "name", name: "name", hidden: false, require: true },
    ],
    propsExport = false,//是否匯出
    propsHandleExport = () => { },//匯出的callback
    propsImport = false,//是否匯入
    propsHandleImport = () => { },//匯入的callback
    propsHandleSample = () => { },//匯入範例的callback
    propsHandleOuter = true,
    headerTitle,//標題
    chartShow: chartShow_ = false,//樹狀圖是否顯示
    chartRoot = "",//樹狀圖根節點名稱
    chartTitle,//樹狀圖名稱
    showSearch = true,
    reloadButton = true,
    manageColumnsButton = true,
    endMessage,
    layoutMode,
    prefixRender, //form前面的呈現（新增的上面）
    extraActionRenderShow = true,//顯示操作
    propsShowSetting = <></>,
    propsCancel = true,
    propsPageSize = 20,
    showTotal,
    showLoader
}) => {
    const navigate = useNavigate()
    const importRef = useRef()
    const [chartShow, setChartShow] = useState(chartShow_)
    const [postChildren, setPostChildren] = useState(propsPostChildren)
    const columns = [
        ...customColumns,
        ...(propsName ? [{
            title: '名稱',
            dataIndex: 'name_language_data',
            key: 'name_language_data',
            render: (text, record, index) => (
                record[`name_language_data`]?.[0]?.language_culture_value !== undefined
                    ? record[`name_language_data`]?.[0].language_culture_value
                    : record.name
            )
        }] : []),
        ...(propsDepth ? [{
            title: '層級資訊',
            dataIndex: 'classify_structure_type_depth_data',
            key: 'classify_structure_type_depth_data',
            render: (text, record, index) => (
                // record[`classify_structure_type_depth_data`]?.map((item) => {
                propsRenderChildrenDataOuter ? renderChildrenData_(record) : renderChildrenData(record)

                // })
            )
        }] : []),
        ...(propsExtend ? [{
            title: '額外資訊',
            dataIndex: 'property_json',
            key: 'property_json',
            render: (text) => <>
                <Row>
                    {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
                </Row>
            </>
        }] : []),
        ...customColumnsSuffix,

    ];

    const [columnExtendOpen, setColumnExtendOpen] = useState(false)
    const classifyStructureTypeDepthId = useRef(null)

    const [languageKey, setLanguageKey] = useState("");
    const [extra_columns, set_extra_columns] = useState([]);
    const internalRef = useRef()
    const actionRef = selectRef || internalRef;
    const [pageSize, setPageSize] = useState(propsPageSize);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[`${prefixTitle}_id`]);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[`${prefixTitle}_id`]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[`${prefixTitle}_id`]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.[`${prefixTitle}_id`]
                );
                selectRow = selectRow.filter(
                    (row) => row[`${prefixTitle}_id`] !== record?.[`${prefixTitle}_id`]
                );
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(propsLoading);
    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("get");
    const [editTarget, setEditTarget] = useState("edit");
    const [treeData, setTreeData] = useState([]);
    const [classifyStructureInitialValues, setClassifyStructureInitialValues] = useState({ ...initialValues })
    const [batchModalOpen, setBatchModalOpen] = useState(false)
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = ({
        classify_structure_id,
        classify_structure_type_id,
        classify_structure_type_parent_id,
    }) => {
        setAxiosMode("post");
        setModalOpen(true);
        setEditTarget('edit');

        if (propsForm) {
            propsForm.resetFields();
            propsForm.setValue("classify_structure_id", classify_structure_id);
            propsForm.setValue(
                "classify_structure_type_id",
                classify_structure_type_id || 0
            );
            propsForm.setValue(
                "classify_structure_type_parent_id",
                classify_structure_type_parent_id || 0
            );
            if (!!initialValues && typeof initialValues === "object") {
                Object.keys(initialValues).forEach((key) => {
                    propsForm.setValue(key, initialValues[key]);
                });
            }
        } else {
            form.resetFields();
            form.setValue("classify_structure_id", classify_structure_id);
            form.setValue(
                "classify_structure_type_id",
                classify_structure_type_id || 0
            );
            form.setValue(
                "classify_structure_type_parent_id",
                classify_structure_type_parent_id || 0
            );
            if (!!initialValues && typeof initialValues === "object") {
                Object.keys(initialValues).forEach((key) => {
                    form.setValue(key, initialValues[key]);
                });
            }
        }
    };
    const handleEditRow = (editTarget, record) => {
        setAxiosMode("patch");
        setModalOpen(true);
        setEditTarget(editTarget);

        if (editTarget === "edit") {
            if (propsForm) {
                propsForm.resetFields();
                Object.keys(record).forEach((key) => {
                    propsForm.setValue(key, record[key]);
                });
            } else {
                form.resetFields();
                Object.keys(record).forEach((key) => {
                    form.setValue(key, record[key]);
                });
            }
        } else if (editTarget === "sort") {
            form.resetFields();
            setTreeData(ResponseData);
        }
    };

    const onFormFinish = (values) => {
        let newValues = reorganizeFormData(values, "submit");
        if (axiosMode === "post") {
            if (custom_multiple_input) {
                postData([newValues]);
            } else {
                postData(newValues);
            }
        } else if (axiosMode === "patch" && editTarget === "edit") {
            patchData([newValues]);
        } else if (axiosMode === "patch" && editTarget === "sort") {
            patchData(values);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reload();
            } else if (axiosMode === "import") {
                message.success("匯入成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
            setModalLoading(false);
            if (axiosMode !== "get") {
                // setModalLoading(false);
                setModalOpen(false);
                setBatchModalOpen(false);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                const error_message =  values.message  || '新增失敗!'
                message.error(error_message);
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false);
            setModalOpen(false);
            setBatchModalOpen(false)
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const handleOnColumnExtendClick = (record) => {
        classifyStructureTypeDepthId.current = record?.classify_structure_type_depth_id
        setColumnExtendOpen(true)
    }

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useTableColumnsCheck(columns);

    const { ResponseData, getData, postData, patchData, deleteData, importData, exportData, downloadData } =
        useCRUDController({
            onFinish,
            onBefore,
            apiRoute: apiRoute,
            propsCancel
        });

    const handleExport = (selectedRowKeys) => {
        exportData()
    }

    const handleImport = ({ file, columns }) => {
        importData({
            target: {
                files: [file]
            }
        })
    }

    const handleSample = () => {
        downloadData()
    }

    const rowSelectionConfig = useMemo(() => ({
        type: rowSelectionMode,
        selectedRowKeys: selectedRowKeys,
        setSelectedRowKeys,
        selectedRowsInfo,
        setSelectedRowsInfo,
        ...rowSelection,
    }), [selectedRowKeys, selectedRowsInfo, rowSelection]);

    const throttledRequest = async (params, sort, filter) => {
        setAxiosMode("get");
        let newParams = {};
        let order = setOrders(sort);
        newParams = {
            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
            ...newParams,
            ...filter,
            classify_structure_id: !!multipleClassifyStructure ? classify_structure_id_arr : classify_structure_id,
            classify_structure_type_id: classify_structure_type_id,
            order,
            size: params?.pageSize,
            cur_page: params.current,
            custom_filter_value: params.keyword ?? "",
            custom_filter_key: custom_filter_key,
            ...extraParams,
            ...filter,
        };

        newParams = setParamsFilter({
            ...newParams,
        });
        setPageSize(params?.pageSize ?? 20);

        return getData(newParams);
    }; // 每 300ms 最多執行一次

    //樹狀圖
    const [orientation, setOrientation] = useState('vertical'); // 預設為垂直
    const treeRef = useRef();
    const transformData = (data) => {
        return data.map((item) => ({
            name: item.name || item.title || "未命名",
            children: item.children ? transformData(item.children) : [],
        }));
    };
    const transformedData = {
        name: chartRoot,
        children: transformData(ResponseData),
    };

    useEffect(() => {
        onSelectChange(selectedRowsInfo, selectedRowKeys)
    }, [selectedRowsInfo])
    useEffect(() => {
    }, [languageKey]);
    useEffect(() => {
        setLanguageKey(prefixTitle + "_language_data");
    }, [prefixTitle]);
    useEffect(() => {
        // document.title = `${prefixTitle} | `;
        checkAll();
    }, []);
    useEffect(() => {
        if (forceReload !== 0) {
            actionRef.current.reloadAndRest();
        }
    }, [forceReload])


    // 下載樹狀圖
    const handleDownload = () => {
        toPng(treeRef.current)
            .then(function (dataUrl) {
                const link = document.createElement('a');
                link.download = 'tree-graph.png';
                link.href = dataUrl;
                link.click();
            })
            .catch(function (error) {
                console.error('Download failed:', error);
            });
    };

    // 自訂節點樣式，使用卡片顯示
    const renderCustomNodeElement = ({
        nodeDatum,
        toggleNode,
        hierarchyPointNode,
    }) => (
        <g>
            {/* 節點外框 - 卡片樣式 */}
            <foreignObject
                width={150} // 卡片的寬度
                height={60} // 卡片的高度
                x={-75} // 調整卡片位置使其居中
                y={-30} // 調整卡片位置使其居中
            >
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    style={{
                        backgroundColor: "#FFF7D1",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "10px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        fontFamily: "Arial, sans-serif",
                    }}
                    onClick={toggleNode} // 點擊展開/收合
                >
                    <strong>{nodeDatum.name}</strong> {/* 節點名稱 */}
                </div>
            </foreignObject>
        </g>
    );

    const renderChildrenData = (data = {}) => {
        let depthData = data?.classify_structure_type_depth_data ?? []
        if (depthData.length === 0 && data.depth < 1) {
            return (<>
                <span style={{ color: 'gray' }}>尚未新增層級資料，請點選修改按鈕進行層級設定</span>
            </>
            )
        }
        return <>
            <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                {depthData?.map((item, depth) => {
                    return (
                        item?.depth_id !== 0 &&
                        <>
                            <Col xxl={12}
                                xl={12}
                                lg={12}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{ alignItem: 'center' }}>
                                第{item?.depth_id}層級：{item?.name}
                            </Col>
                            {!readonly && <Col xxl={12}
                                xl={12}
                                lg={12}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{ alignItem: 'center' }}>
                                <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    <Col>
                                        <Button
                                            style={{
                                                backgroundColor: '#FFBD73', // 主色：橙色
                                                color: '#5a3a00', // 文字色：深棕色
                                                padding: '10px 20px',
                                                border: 'none',
                                                borderRadius: '5px',
                                            }}
                                            size={"small"}
                                            onClick={(e) => {
                                                navigate('./../depth?' + jsonToQueryString({ classify_structure_type_depth_id: item?.classify_structure_type_depth_id, classify_structure_type_id: item?.classify_structure_type_id }))
                                            }}>資料設定</Button>
                                    </Col>
                                    <Col>
                                        {/* 職位綁定未完成 */}
                                        {/* <BindRoleButton /> */}
                                    </Col>
                                </Row>
                            </Col>}
                        </>
                    );
                })
                }
            </Row>
        </>
    }
    return (
        <>
            <ClassifyStructureModal
                axiosMode={axiosMode}
                editTarget={editTarget}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={propsForm ? propsForm : form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                propsOnValueChange={propsOnValueChange}
                onFinish={onFormFinish}
                customFormItems={customFormItems}
                initialTreeData={treeData}
                defaultValue={defaultValue}
                prefixTitle={prefixTitle}
            // classifyStructureData={}
            />
            {propsExtend && <ColumnExtendButton
                propsOpen={columnExtendOpen}
                propsSetOpen={setColumnExtendOpen}
                classifyStructureTypeDepthId={classifyStructureTypeDepthId.current}
                classifyStructureId={!!multipleClassifyStructure ? classify_structure_id_arr : classify_structure_id}
                apiRouteDepth={apiRouteDepth}
            />}
            <ProTableOt
                key={forceReload}
                actionRef={actionRef}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={`${prefixTitle}_id`}
                selections={
                    {
                        // onChange: (index_, data_) => set_data(data_)
                    }
                }
                toolBarRender={() => toolBarRender([
                    !readonly && propsSort && <Button
                        type="primary"
                        style={{
                            color: "#000",
                            backgroundColor: "#ffedee",
                        }}
                        onClick={(e) => handleEditRow("sort")}
                    >
                        項目排序
                    </Button>,
                    ...(!readonly && propsExport ? [<Button
                        style={{ background: '#1565C0', color: '#ffffff' }}
                        onClick={() => {
                            if (propsHandleOuter) {
                                propsHandleExport(selectedRowKeys)
                            } else {
                                handleExport(selectedRowKeys)
                            }
                        }}
                    >
                        匯出資料
                        <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                    </Button>] : []),
                    ...(!readonly && propsImport ? [
                        <>
                            <Button
                                style={{ backgroundColor: '#388E3C', color: '#FFFFFF' }}
                                onClick={(e) => importRef.current.click()} >
                                匯入資料
                                <FontAwesomeIcon icon={faFileImport} style={{ marginLeft: '2px' }} />
                            </Button>
                            <input
                                type="file"
                                hidden
                                ref={importRef}
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    if (propsHandleOuter) {
                                        propsHandleImport({ file, columns })
                                    } else {
                                        handleImport({ file, columns })
                                    }
                                    importRef.current.value = ""
                                }}
                            />
                        </>] : []),
                    ...(!readonly && propsImport ? [<Button
                        style={{ background: '#616161', color: '#ffffff' }}
                        onClick={() => {
                            if (propsHandleOuter) {
                                propsHandleSample(selectedRowKeys)
                            } else {
                                handleSample(selectedRowKeys)
                            }
                        }}
                    >
                        下載範例資料
                        <FontAwesomeIcon icon={faFileAlt} style={{ marginLeft: '2px' }} />
                    </Button>] : [])
                ])}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) =>{
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        ...filter,
                        classify_structure_id: !!multipleClassifyStructure ? classify_structure_id_arr : classify_structure_id,
                        classify_structure_type_id: classify_structure_type_id,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        ...extraParams,
                        ...filter,
                    };
            
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);
            
                    return getData(newParams);
                }}
                pageSize={pageSize}
                showMode={showMode}
                cardRender={cardRender}
                cardModeSetting={cardModeSetting}
                rowSelection={!!rowSelectionMode ? rowSelectionConfig : false}

                tableAlertOptionRender={() => {
                    return (
                        <Row gutter={[16, 16]}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Row>
                    );
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Row size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Row>
                    );
                }}
                scroll={{
                    x: "max-content",
                }}
                defaultExpandAllRows={true}
                propsUseData={() => {

                    return {

                        postData: (data) => {
                            let datas = [...data]
                            datas = datas.map((values) => {
                                return reorganizeFormData(values, "submit")
                            })
                            if (!!custom_multiple_input) {
                                postData(datas)
                            }
                            else {
                                datas.forEach((ele) => {
                                    postData(ele);
                                })
                            }
                        },
                        patchData: (data) => {
                            let newValues = data.map((record) => {
                                return {
                                    ...reorganizeFormData(record, "submit")
                                }
                            })
                            patchData(newValues);
                        },
                        deleteData: deleteData,
                    }
                }}
                PropsPatchForm={<ClassifyStructureForm
                    axiosMode={axiosMode}
                    // propsForm={propsForm ? propsForm : form}
                    onFormFinish={formMode ? undefined : onFormFinish}
                    formMode={formMode}
                    propsShowKeys={propsShowKeys}
                    customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, field, onFormFinish) => {
                        const classify_structure_type_parent_id = formValues?.classify_structure_type_parent_id
                        return <>
                            {propsDepth && (classify_structure_type_parent_id === 0 || classify_structure_type_parent_id === undefined) && <ClassifyStructureDepthForm fieldName={fieldName} prefix={'classify_structure_type'} propsForm={propsCustomForm} propsFirstDepth={propsFirstDepth} />}
                            {propsExtend && <Form.Item
                                name={formMode ? [field?.name ?? '', 'property_json'] : [fieldName ?? '', 'property_json']}
                            >
                                <PropertyJson actionMode={"postValue"} />
                            </Form.Item>}
                            {customFormItems(fieldName, formValues, onValuesChange, propsCustomForm, propsOnValueChange, field, onFormFinish)}
                        </>
                    }}
                    defaultValue={defaultValue ? defaultValue : classifyStructureInitialValues}
                    propsOnValuesChange={propsOnValueChange}
                />}

                propsPatchOnBefore={() => { }}
                propsPatch={propsPatch}
                propsPost={propsPost}
                propsPostChildren={postChildren}
                propsPostChildrenKey={propsPostChildrenKey}
                propsPostOnBefore={(record) => {
                    setEditTarget('edit');
                    if (!!record) {
                        setClassifyStructureInitialValues((pre) => {
                            return {
                                ...pre,
                                ...(propsPostChildrenKey?.reduce((pre, [key, value]) => (
                                    {
                                        ...pre,
                                        [key]: record?.value
                                    }
                                ), {})),
                                classify_structure_id: classify_structure_id,
                                classify_structure_type_id: record?.classify_structure_type_id || 0,
                                classify_structure_type_parent_id: record?.classify_structure_type_id || 0,
                            }
                        })
                    }
                    else {
                        setClassifyStructureInitialValues((pre) => {
                            return {
                                ...initialValues,
                            }
                        })
                    }
                }}
                initialValues={classifyStructureInitialValues}
                propsDelete={propsDelete}
                modalOpen={batchModalOpen}
                setModalOpen={setBatchModalOpen}
                propsPatchProcess={(record) => {
                    setEditTarget('edit');
                    return ({
                        ...reorganizeFormData(record, "set")
                    })
                }}
                propsWidth={propsWidth}
                extraActionRender={(record) => {
                    return <>
                        <Row>
                            {!readonly && <Col hidden={!propsExtend || (record?.depth !== 0 ?? record?.classify_structure_type_depth_id === null)}>
                                <Button onClick={() => handleOnColumnExtendClick(record)}>欄位擴充設定</Button>
                            </Col>}
                            <Col {...(propsExtend ? {} : { span: 24 })}>
                                {extraActionRender(record)}
                            </Col>
                        </Row>
                    </>

                }}
                propsDeleteModal={propsDeleteModal}
                propsChildrenText={propsChildrenText}
                readonly={readonly}
                formMode={formMode}
                headerTitle={headerTitle}
                showSearch={showSearch}
                reloadButton={reloadButton}
                manageColumnsButton={manageColumnsButton}
                endMessage={endMessage}
                layoutMode={layoutMode}
                prefixRender={prefixRender}
                extraActionRenderShow={extraActionRenderShow}
                showSetting={<>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            {propsShowSetting}
                        </Col>
                        <Col>顯示樹狀圖：<Switch
                            value={chartShow}
                            name={''}
                            checkedChildren={'開'}
                            unCheckedChildren={'關'}
                            onChange={e => setChartShow(e.target.value)}
                        /></Col>
                        <Col>新增子項目：<Switch
                            value={postChildren}
                            name={''}
                            checkedChildren={'開'}
                            unCheckedChildren={'關'}
                            onChange={e => setPostChildren(e.target.value)}
                        /></Col>
                    </Row>
                </>}
                showTotal={showTotal}
                showLoader={showLoader}
            />
            {ResponseData.length !== 0 && chartShow &&
                <>
                    <Divider>
                    </Divider>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col>
                                    <Typography.Title level={3}>
                                        {chartTitle ?? `樹狀圖`}
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <Button style={{ background: '#1565C0', color: '#ffffff' }} onClick={handleDownload}>
                                        下載樹狀圖 <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                                    </Button>
                                </Col>
                                <Button
                                    style={{
                                        background: orientation === 'vertical' ? '#4CAF50' : '#FF9800',
                                        color: '#ffffff'
                                    }}
                                    onClick={() => setOrientation(orientation === 'vertical' ? 'horizontal' : 'vertical')}>
                                    {orientation === 'vertical' ?
                                        <>
                                            樹狀圖垂直呈現
                                            <FontAwesomeIcon icon={faArrowUp} style={{ marginLeft: '2px' }} />
                                            <FontAwesomeIcon icon={faArrowDown} />
                                        </>
                                        :
                                        <>
                                            樹狀圖水平呈現
                                            <FontAwesomeIcon icon={faArrowLeft} style={{ marginLeft: '2px' }} />
                                            <FontAwesomeIcon icon={faArrowRight} />
                                        </>
                                    }
                                </Button>
                            </Row>
                        </Col>
                        <Col span={24}
                            ref={treeRef}
                            style={{
                                display: 'flex',
                                justifyContent: 'center', // 水平居中
                                alignItems: 'center', // 垂直居中
                                height: '80vh', // 固定高度
                                backgroundColor: '#fff',
                                padding: '20px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                            }}
                        >
                            <Tree
                                data={transformedData}
                                zoomable={true}
                                renderCustomNodeElement={renderCustomNodeElement} // 使用自訂節點
                                pathFunc="step"
                                orientation={orientation} // 垂直樹狀圖
                                nodeSize={{ x: 200, y: 100 }} // 節點之間的間距
                                translate={{ x: 300, y: 50 }} // 樹的位置偏移
                            />
                        </Col>
                    </Row>
                </>
            }
        </>
    );
};

const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};

export default Main;

const Demo = ({
    keyPrefix = "classify_structure.classify_structure",
    customFormItems = () => { }, //上層可加入自定義的form item 
    classifyStructureApi = '/utility/classify_structure_type', //department 的api 名稱
    customColumns = [], //列表編輯模式的顯示columns
    propsCardRender = () => { }, //card 模式要顯示的其他欄位
    propsClassifyStructureId = 1,
    propsClassifyStructureTypeId = 0,
    propsOrigin = false
}) => {
    const ClassifyStructure = Main
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [searchParams] = useSearchParams()
    const departmentIdExternal = searchParams?.get('classify_structure_type_id')
    const navigate = useNavigate()
    const [departmentData, setDepartmentData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [departmentProcessData, setDepartmentProcessData] = useState([]);
    const [roleProcessData, setRoleProcessData] = useState([]);
    const [departmentId, setDepartmentId] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [departmentName, setDepartmentName] = useState([]);
    const [roleName, setRoleName] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({
        edit: true,
        prefix: "department",
        languageKey: "name_language_data",
        node: [],
        data: { name: "" }
    });
    const current_department_id = useRef()
    const selectRef = useRef()
    const [forceReload, setForceReload] = useState(0);
    const tabShowMode = useRef("page")
    const [showMode, setShowMode] = useState("page");
    const [loading, setLoading] = useState(true)
    const [modalOpen, setModalOpen] = useState(false);

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    };

    const addModal = (prefix, languageKey, node) => {
        setModalData((prev) => {
            return {
                edit: false,
                prefix: prefix,
                languageKey: languageKey,
                node: node,
                data: { name: "" }
            }
        })
        setModalShow(true)
    }

    const editModal = (prefix, languageKey, node) => {
        let data = {
            "name": node[`${languageKey}`]?.[0]?.language_culture_value !== undefined
                ? node[`${languageKey}`]?.[0]?.language_culture_value
                : node.name

        }
        setModalData({
            edit: true,
            prefix: prefix,
            languageKey: languageKey,
            node: node,
            data: data
        })
        setModalShow(true)
    }
    const deleteDepartment = (node, classify_structure_type_id) => {
        let url = classifyStructureApi;
        let data = [{
            "department_id": node.department_id,
            "classify_structure_id": propsClassifyStructureId,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("department", url, data, classify_structure_type_id)

    }

    //刪除訊息、找刪除節點
    const deleteNode = (type, url, data, classify_structure_type_id) => {
        axios
            .delete(url, { data: data })
            .then(response => {
                if (response.data.status === "success") {
                    message.success('刪除成功');
                    if (type === "department") {
                        setDepartmentProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.department_id === departmentId) {
                            setDepartmentId(null)
                        }
                    }
                    else {
                        setRoleProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.role_id === roleId) {
                            setRoleId(null)
                        }
                    }
                }
                else {
                    message.error('刪除失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {

            })
    };
    const getDepartmentId = (node) => {
        if (node) {
            setDepartmentId(node?.department_id)
            let name = node?.name_language_data[0].language_culture_value
            setDepartmentName(name !== undefined ? name : node?.name)
        }
        else {
            setDepartmentId(null)
        }
    }
    const getRoleId = (node) => {
        if (node) {
            setRoleId(node?.role_id)
            let name = node?.role_language_data[0].language_culture_value
            setRoleName(name !== undefined ? name : node?.name)
        }
        else {
            setRoleId(null)
        }
    }
    const onChange = (newTargetKeys, direction, moveKeys) => {
        setTargetKeys(newTargetKeys);
    };
    const postUserRole = (departmentId, roleId, userIdArray) => {
        let data = [{
            "department_id": departmentId,
            "role_id": roleId,
            "user_id": userIdArray,
        }]
        axios.post('/organization_structure/api/user_role', data)
            .then(response => {
                if (response.data.status === "success") {
                    message.success('儲存成功');
                }
                else {
                    message.error('儲存失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setRoleId(undefined)
            })
    };
    const isInteger = (value) => {
        // Convert the value to an integer using parseInt
        let parsedValue = parseInt(value, 10);
        // Check if the parsed value is NaN or not equal to the original value (converted to a string)
        return !isNaN(parsedValue) && parsedValue.toString() === value.toString();
    }

    const renderChildrenData = (data = {}) => {
        let depthData = data?.classify_structure_type_depth_data ?? []
        if (depthData?.length === 0) {
            return (<>
                <span style={{ color: 'gray' }}>尚未新增層級資料，請點選修改按鈕進行層級設定</span>
            </>
            )
        }
        return <>
            <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                {depthData?.map((item, depth) => {
                    return (
                        item?.depth_id !== 0 &&
                        <>
                            <Col xxl={12}
                                xl={12}
                                lg={12}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{ alignItem: 'center' }}>
                                第{item?.depth_id}層級：{item?.name}
                            </Col>
                            <Col xxl={12}
                                xl={12}
                                lg={12}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{ alignItem: 'center' }}>
                                <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    <Col>
                                        <Button
                                            style={{
                                                backgroundColor: '#FFBD73', // 主色：橙色
                                                color: '#5a3a00', // 文字色：深棕色
                                                padding: '10px 20px',
                                                border: 'none',
                                                borderRadius: '5px',
                                            }}
                                            size={"small"}
                                            onClick={(e) => {
                                                navigate('./../depth?' + jsonToQueryString({ classify_structure_type_depth_id: item?.classify_structure_type_depth_id, classify_structure_type_id: item?.classify_structure_type_id }))
                                            }}>資料設定</Button>
                                    </Col>
                                    <Col>
                                        {/* 職位綁定未完成 */}
                                        {/* <BindRoleButton /> */}
                                    </Col>
                                </Row>
                            </Col>
                        </>
                    );
                })
                }
            </Row>
        </>
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
                setLoading(false)
            } else if (axiosMode === "post") {
                message.success("新增成功");
                selectRef.current.reloadAndRest()
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                selectRef.current.reloadAndRest()
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }

    const rolePropertyJsonController = useCRUDController({
        onBefore,
        onFinish,
        apiRoute: '/organization_structure/api/role_property_json'
    })

    useEffect(() => {
        if (userData) {
            axios.get('/organization_structure/api/user_role', {
                params: {
                    department_id: departmentId,
                    role_id: roleId
                }
            })
                .then(response => {
                    let newTargetKeys = []
                    newTargetKeys = response.data['data'].map((map_item, index) => (
                        map_item.user_id.toString()
                    ))
                    setTargetKeys(newTargetKeys)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [userData])

    useEffect(() => {
        setUserData([])
        if (roleId) {
            axios.get('/organization_structure/api/user')
                .then(response => {
                    let newUserData = []
                    newUserData = response.data?.data?.map((map_item, index) => {
                        return {
                            key: String(map_item.user_id),
                            title: `${map_item.staff_name}-${map_item.serial_name}`
                        }
                    })
                    setUserData(newUserData)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [roleId])

    const init = async () => {
        let firstDepartment
        await axios.get(classifyStructureApi, {
            params: {
            }
        })
            .then(response => {
                firstDepartment = response.data['data']?.find(_ => true)?.department_id
            })
            .catch((error) => {
            })
            .finally(() => {
            })
        if (departmentIdExternal) {
            current_department_id.current = departmentIdExternal
            setDepartmentId(isInteger(departmentIdExternal) ? parseInt(departmentIdExternal) : departmentIdExternal)
        } else if (firstDepartment) {
            current_department_id.current = firstDepartment
            setDepartmentId(isInteger(firstDepartment) ? parseInt(firstDepartment) : firstDepartment)
        }
    }

    useEffect(() => {
        init()
        rolePropertyJsonController.getData()
    }, [])

    useEffect(() => {
    }, [targetKeys])
    useEffect(() => {
        setForceReload(pre => pre + 1)
    }, [current_department_id.current])

    return <>
        <ClassifyStructure
            selectRef={selectRef}
            propsForm={form}
            prefixTitle="classify_structure_type"
            apiRoute={classifyStructureApi}
            customColumns={[
                ...customColumns,
            ]}
            extraActionRender={(record) => <>
            </>}
            propsPostChildren={true}
            customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm) => {
                return <>
                    <Form.Item
                        name={"classify_structure_type_parent_id"}
                        hidden
                    ></Form.Item>
                    <Form.Item
                        name={"classify_structure_type_id"}
                        hidden
                    ></Form.Item>
                    <Form.Item
                        name={"name_language_data.0.language_manage_id"}
                        hidden
                    ></Form.Item>
                    <Form.Item
                        name={"name_language_data.0.language_culture_code"}
                        hidden
                    >
                    </Form.Item>
                    <Form.Item
                        name={"name_language_data.0.language_culture_value"}
                        hidden
                    >
                    </Form.Item>
                    {customFormItems(fieldName)}
                </>
            }}
            propsSort={false}
            classify_structure_id={propsClassifyStructureId}
            classify_structure_type_id={propsClassifyStructureTypeId}
            initialValues={{
                "name_language_data": [
                    {
                        "language_manage_id": undefined,
                        "language_culture_code": "zh-tw",
                        "language_culture_value": ""
                    }
                ]
                // permission_id: null,
                // path_check: 0,
                // path_check_replace: false,
                // show_replace: false,
                // show: 0,
                // menu_permission_data: [{
                //     // menu_id: current_department_id?.current
                // }],
                // property_json: {
                //     blod: false,
                //     italic: false,
                //     textDecoration: false,
                //     background_color1: null,
                //     background_color2: null
                // }

            }}
            reorganizeFormData={(value, type) => {
                if (type === "submit") {
                    let newData = [{
                        "classify_structure_type_parent_id": value?.classify_structure_type_parent_id,
                        "classify_structure_id": propsClassifyStructureId,
                        "classify_structure_type_id": value?.classify_structure_type_id,
                        "name": value?.name,
                        "name_language_data": [
                            {
                                "language_manage_id": value?.name_language_data?.[0]?.language_manage_id,
                                "language_culture_code": "zh-tw",
                                "language_culture_value": value?.name
                            }
                        ],
                        "classify_structure_type_depth_data": value?.classify_structure_type_depth_data,
                        "property_json": value?.property_json
                    }]
                    let firstData = newData.find((ele) => true)
                    return {
                        ...firstData
                    };
                } else if (type === "set") {
                    let newData = [{
                        "classify_structure_type_parent_id": value?.classify_structure_type_parent_id,
                        "classify_structure_id": propsClassifyStructureId,
                        "classify_structure_type_id": propsOrigin ? value?.classify_structure_type_id : value?.classify_structure_type_parent_id,
                        "name": value?.name,
                        "name_language_data": [
                            {
                                "language_manage_id": value?.name_language_data?.[0]?.language_manage_id,
                                "language_culture_code": "zh-tw",
                                "language_culture_value": value?.name
                            }
                        ],
                        "classify_structure_type_depth_data": value?.classify_structure_type_depth_data,
                        "property_json": value?.property_json
                    }]
                    let firstData = newData.find((ele) => true)
                    return {
                        ...firstData
                    };
                }
            }}
            extraParams={{
                // menu_id: current_department_id.current
            }}
            // forceReload={forceReload}
            chartShow={true}
            treeData={departmentData}
            onSubmit={addModal}
            onChange={editModal}
            processData={departmentProcessData}
            deleteNode={deleteDepartment}
            onSelect={getDepartmentId}
            chartTitle={'單位組織架構圖'}
            treeTitle={''}
            extra_column={[
                // {
                //     title: '職位數',
                //     dataIndex: 'count_role',
                //     key: 'count_role'
                // },
                // {
                //     title: '人員數',
                //     dataIndex: 'count_user',
                //     key: 'count_user'
                // },
            ]}
            link={(record) => {
                navigate('./../role?' + jsonToQueryString({ department_id: record?.department_id }))
            }}
            showMode={showMode}
            cardRender={(record, { PatchButton, DeleteButton }) => {
                return <>
                    <Card title={`系統角色：${record.title}`}
                        styles={{
                            height: "400px",
                            overflow: 'scroll'
                        }}
                    >
                        <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                            <Col>
                                {PatchButton}
                            </Col>
                            <Col>
                                {DeleteButton}
                            </Col>
                            <Col span={24}>
                                {propsCardRender(record)}
                            </Col>
                            <Col span={24}>
                                {renderChildrenData(record)}
                            </Col>
                        </Row>
                    </Card>
                </>
            }}
            renderChildrenData={renderChildrenData}
            cardModeSetting={{
                columnsCount: 2,
                singleRowHeight: '100vh',
            }}
            toolBarRender={(tools) => {
                return [
                    <Col>
                        <Tabs
                            defaultActiveKey={"page"}
                            items={[
                                {
                                    key: "card",
                                    tab: '區塊呈現'
                                },
                                {
                                    key: "page",
                                    tab: '列表呈現'
                                },
                            ]}
                            onChange={(value) => {
                                tabShowMode.current = value
                                setShowMode(value)
                            }}
                        />
                    </Col>,
                    ...tools
                ]
            }}
            custom_multiple_input={true}
            propsDepth={true}
            propsExtend={true}
        />
    </>
}
export { Demo }

